import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CdpLoanCalculator from "./component";
import { setRedirectRoute } from "../car-details/actions";
import { getMinMaxInterestRates, setPreApprovedOrigin } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { startPreApprovalOnFly } from "../pre-approval-on-fly-modal/actions";

const mapStateToProps = ({
    carDetails: {
        content
    },
    user: {
        isLoggedIn
    },
    preApprovalLoan: {
        preApproved,
        minMaxInterestRateInfo,
        loanCalculatorInfo,
        maxPermissibleRepaymentPerWeek,
        financeData: {
            loanType: {
                isPurposeBusiness } = {}
        } = {}
    },
    checkout: {
        stEligibleData
    },
    abExperiment: {
        preApprovalOnFlyDesktop
    } = {}
}) => ({
    content,
    isLoggedIn,
    preApproved,
    minMaxInterestRateInfo,
    loanCalculatorInfo,
    stEligibleData,
    maxPermissibleRepaymentPerWeek,
    isPurposeBusiness,
    preApprovalOnFlyDesktop
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setRedirectRouteConnect: setRedirectRoute,
    getMinMaxInterestRatesConnect: getMinMaxInterestRates,
    setPreApprovedOriginConnect: setPreApprovedOrigin,
    startPreApprovalOnFlyConnect: startPreApprovalOnFly
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CdpLoanCalculator);
